import { ConnectedBuyFormatCurrency } from '@buy/connectedComponents'
import React, { FunctionComponent } from 'react'
import { Tooltip } from '@common/components'
import { BillingPeriod } from '@common/constants'
import { isEmpty } from 'lodash-es'
import styles from '../../connectedComponents/OrderSummary/order-summary.module.css'
import { BillingTenureValue } from '../BillingPeriodSwitch'

interface CouponDiscountSummaryProps {
    percentageOffPromoDiscountLabel: string
    promoDiscountForAnnualSavingsTooltipLabel: string
    billingTenure?: BillingTenureValue
    couponDiscount: number | undefined
    sku: string
    percent: number
}

export const CouponDiscountSummary: FunctionComponent<CouponDiscountSummaryProps> = ({
    percentageOffPromoDiscountLabel,
    promoDiscountForAnnualSavingsTooltipLabel,
    billingTenure,
    sku,
    couponDiscount = 0,
    percent,
}) => {
    return (
        <>
            {couponDiscount > 0 && (
                <div key={`${`coupon-discount${sku}`}`} className={styles['sub-section']} data-qat="coupon-discount">
                    <div className={styles.row}>
                        <span className={`${styles.small} ${styles.teal}`}>
                            <span data-qat="coupon-discount-percentage">
                                {percent > 0 ? `${percent}%` : <ConnectedBuyFormatCurrency value={couponDiscount} />}
                                &nbsp;
                            </span>
                            {percentageOffPromoDiscountLabel}
                            {billingTenure &&
                                billingTenure.selected === BillingPeriod.ANNUAL &&
                                !isEmpty(promoDiscountForAnnualSavingsTooltipLabel) && (
                                    <Tooltip
                                        content={promoDiscountForAnnualSavingsTooltipLabel}
                                        additionalClass={styles['order-tooltip']}
                                        contentClass={styles['order-tooltip-content']}
                                    />
                                )}
                        </span>
                        <span className={`${styles.small} ${styles.teal}`} data-qat="coupon-discount-price">
                            -
                            <ConnectedBuyFormatCurrency value={couponDiscount} />
                        </span>
                    </div>
                </div>
            )}
        </>
    )
}
